import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './index.scss';
import '../scss/public.scss';
import Color from '@tool/color';
import { exportExcelFile, locateValue } from '@tool/index';
import Head from '../../component/head';
import {
  ChartIconInActive,
  ChartIconActive,
  TableIconInActive,
  TableIconActive,
  LightIcon,
} from '@styled/icon';
import moFreshSalary, { initFreshSalary, changeType } from './store';
import Chart from './chart';
import CommonTable from '../../component/common-table';
import GradeTable from './grade-table';
import TimeTab from '../../component/time-tab';
import Empty from '@comp/empty/index';
import moIndex, { changeFreshYear, toggleTip } from '../../store/index';
import moUser from '@store/user';
import { toJS } from 'mobx';

interface IProps {}
interface IState {}

const DIconButton = styled(IconButton)(() => ({
  width: '32px',
  height: '20px',
  marginRight: '2px',
  borderRadius: '3px',
}));

const ActiveType = styled(DIconButton)(() => ({
  backgroundColor: Color.primary,
  '&:hover': { backgroundColor: Color.primary },
}));

const InActiveType = styled(DIconButton)(() => ({
  backgroundColor: Color.fff,
  '&:hover': { backgroundColor: Color.fff },
}));

// 涨薪率 - 行业应届生起薪
const FreshSalary = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { freshYear, freshYearList, isMock } = moIndex;
  const { isLogin } = moUser;
  const { type, overview, labels, tableHead, tableList, xData, yData } =
    moFreshSalary;
  const [width, setWidth] = useState(680);

  const calcLen = () => {
    let wid = 680;
    if (xData.length <= 6) wid = 680;
    else if (xData.length <= 9) wid = 1020;
    else if (xData.length <= 12) wid = 1360;
    else if (xData.length <= 15) wid = 1700;
    else if (xData.length <= 18) wid = 2040;
    else wid = 2380;
    setWidth(wid);
  };

  const exporttable = () => {
    if (moUser.isIndicatorExpired) {
      toggleTip(true);
      return;
    }
    const head: any = [
      ['行业', '大专', '本科', '', '', '硕士', '', '', '博士', '', ''],
      [
        '',
        '不区分',
        '不区分',
        '普通院校',
        '重点院校',
        '不区分',
        '普通院校',
        '重点院校',
        '不区分',
        '普通院校',
        '重点院校',
      ],
    ];
    const content: any = [];
    tableList.forEach((item: any) => {
      content.push([item.title, ...item.arr]);
    });
    const list: any = [...head, ...content];
    const merge = [
      { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
      { s: { r: 0, c: 2 }, e: { r: 0, c: 4 } },
      { s: { r: 0, c: 5 }, e: { r: 0, c: 7 } },
      { s: { r: 0, c: 8 }, e: { r: 0, c: 10 } },
    ];
    exportExcelFile(list, merge, '行业应届生起薪');
  };

  useEffect(() => {
    calcLen();

    return () => {};
  }, [xData.length]);

  return (
    <section id="indicator3" className="fresh-salary_10">
      <Head title="人力指标" bigTitle="应届生起薪" />
      <section className="category-fresh-salary_10">
        <p className="one-11">
          <strong>行业应届生起薪</strong>
          <span className="tag-01">行业比对</span>
          {type === 'chart' ? (
            <ActiveType>
              <ChartIconActive />
            </ActiveType>
          ) : (
            <InActiveType onClick={() => changeType('chart')}>
              <ChartIconInActive />
            </InActiveType>
          )}
          {type === 'table' ? (
            <ActiveType>
              <TableIconActive />
            </ActiveType>
          ) : (
            <InActiveType onClick={() => changeType('table')}>
              <TableIconInActive />
            </InActiveType>
          )}
        </p>
        <p className="one-1303">
          <span style={{ color: '#878787' }}>
            <LightIcon color={Color.primary} />
            &nbsp;了解普通院校、重点院校的应届生起薪，请切换至表格查看
          </span>
        </p>
        {type === 'chart' ? (
          <>
            {!isEmpty(xData) ? (
              <section className="box-11">
                <section
                  className={['box-13', !isMock ? '' : 'mock-100'].join(' ')}
                  style={{ overflowY: 'auto' }}>
                  <section className="chart-title_03">
                    {labels.map((item: any, idx: number) => (
                      <p
                        key={idx}
                        className="line-03"
                        style={{ marginRight: '10px', paddingLeft: '10px' }}>
                        <strong>{locateValue(item.value)}</strong>
                        <span style={{ lineHeight: 1.3, marginLeft: '8px' }}>
                          {item.text}
                        </span>
                      </p>
                    ))}
                  </section>
                  <section
                    style={{
                      width: '100%',
                      overflowY: 'auto',
                    }}>
                    <Chart height={300} xData={xData} yData={yData} />
                  </section>
                </section>
                <section className="box-150">
                  <strong>解读：</strong>
                  <section className="box-151">
                    {overview.map((text: any, index: number) => (
                      <p key={index}>
                        <span className="ico-11">
                          <b />
                        </span>
                        <i>{text}</i>
                      </p>
                    ))}
                  </section>
                </section>
              </section>
            ) : (
              <Empty padding="50px 0" />
            )}
          </>
        ) : (
          <>
            {type === 'table' && (
              <section onClick={exporttable} className="export-table">
                导出excel
              </section>
            )}
            {!isEmpty(tableList) ? (
              <GradeTable tableHead={tableHead} tableArr={tableList} />
            ) : (
              <Empty padding="50px 0" />
            )}
          </>
        )}

        {!isEmpty(xData) ? (
          <TimeTab
            active={freshYear}
            list={freshYearList}
            onChange={changeFreshYear}/>
        ) : null}
      </section>
    </section>
  );
};

export default observer(FreshSalary);
